import React, { ReactNode } from 'react';
import {
    Expander,
    ExpanderBorderRoundingStyle,
    ExpanderButtonStyle,
    ExpanderTheme,
    ExpanderExpandedHeaderTheme,
} from '@apply/components';

interface MobileDrawBudgetCategoryParameters {
    header: ReactNode;
    children: ReactNode;
}

export const MobileDrawBudgetCategory: React.FC<MobileDrawBudgetCategoryParameters> = ({ header, children }) => {
    return (
        <Expander
            header={header}
            theme={ExpanderTheme.White}
            buttonStyle={ExpanderButtonStyle.NoRounding}
            borderRoundingStyle={ExpanderBorderRoundingStyle.NoRounding}
            expandedHeaderTheme={ExpanderExpandedHeaderTheme.Blue}
            initialExpanded={true}
        >
            {children}
        </Expander>
    );
};
